function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { twMerge } from "../../../utils";
import { CallToAction, NavItem } from "../../atoms";
import { ArrowRight, SmallChevronLeft } from "../../icons";
export function MenuList(param) {
    var header = param.header, items = param.items, callToAction = param.callToAction, className = param.className;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement("nav", {
        className: twMerge("grid grid-cols-1 grid-flow-row auto-rows-min", className)
    }, !!header && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: cx("grid items-center grid-cols-[auto_minmax(0,1fr)]", "px-3 py-6 border-b border-b-fg-inbetween font-medium text-body.base bg-bg-offdefault text-left"),
        onClick: header.onClick
    }, /*#__PURE__*/ React.createElement("span", {
        role: "presentation",
        className: "p-3 mr-4 text-brand-primary-base"
    }, /*#__PURE__*/ React.createElement(SmallChevronLeft, {
        className: "block"
    })), /*#__PURE__*/ React.createElement("span", null, header.label)), items.map(function(item) {
        return /*#__PURE__*/ React.createElement(NavItem, _extends({}, item, {
            key: seed(item),
            className: "px-3 py-6 border-b border-b-fg-inbetween text-body.base"
        }), item.label);
    }), !!callToAction && /*#__PURE__*/ React.createElement("div", {
        className: "mt-5"
    }, /*#__PURE__*/ React.createElement(CallToAction, _extends({}, callToAction, {
        style: "button",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    }), callToAction.label)));
}

//# sourceMappingURL=MenuList.js.map